import { render } from "./RichMarkdownEditor.vue?vue&type=template&id=0c2c5525&scoped=true"
import script from "./RichMarkdownEditor.vue?vue&type=script&lang=js"
export * from "./RichMarkdownEditor.vue?vue&type=script&lang=js"

import "./RichMarkdownEditor.vue?vue&type=style&index=0&id=0c2c5525&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2c5525"]])

export default __exports__